import { Box, Typography, type SxProps, type Theme } from '@mui/material'
import { AlertCircleIcon } from '@untitled-theme/icons-react'

import InfoChip from '@/shared/components/InfoChip'

interface PropertyValueIncreaseProps {
  percentage?: number
  sx?: SxProps<Theme>
}

const PropertyValueIncrease = ({ percentage, sx }: PropertyValueIncreaseProps) => {
  const hasPercentage = percentage !== undefined && percentage > 0

  return (
    <Box
      sx={{
        backgroundColor: '#ffffff',
        borderRadius: '8px',
        boxShadow: 'inset 0 0 0 1px #E1E1E4',
        padding: '23px 16px 15px 16px',
        ...sx,
      }}
    >
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: '14px',
          lineHeight: '20px',
        }}
      >
        Immobilienwertsteigerung
      </Typography>
      {hasPercentage ? (
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: '18px',
            lineHeight: '33px',
            marginTop: '4px',
          }}
        >
          {`${percentage.toFixed(2)} %`}
        </Typography>
      ) : (
        <InfoChip
          label="Keine Verbesserung"
          icon={<AlertCircleIcon style={{ width: '16px', height: '16px', color: '#464A54' }} />}
          sx={{
            marginTop: '9px',
            marginBottom: '6px',
          }}
        />
      )}
    </Box>
  )
}

export default PropertyValueIncrease
